import {
  IterableEmbeddedMessageProps,
  IterableEmbeddedSlot,
  IterableEmbeddedRenderers,
} from '@care/iterable-display';
import { Box } from '@mui/material';
import { AmplitudeEvent, trackAmplitudeEvent } from '@/lib/analyticsHelper';
import useFeatureFlag from '@/components/hooks/useFeatureFlag';

const getIterableAmplitudeData = (message: IterableEmbeddedMessageProps) => ({
  messageId: message.metadata.messageId,
  campaignId: message.metadata.campaignId,
  placementId: message.metadata.placementId,
  campaign: message.payload?.campaign,
  assetLocation: 'VHP',
  assetText: message.elements?.body ?? /* istanbul ignore next */ '',
  assetType: 'banner',
});

interface IterableBannerProps {
  placementId: number;
  slotProps?: {
    bannerContainer: {
      'data-testid'?: string;
    };
  };
}

export const IterableBanner = ({ placementId, slotProps }: IterableBannerProps) => {
  const iterableCampaignFlag = useFeatureFlag('visitor-iterable-campaign-active');
  const isIterableCampaignActive = iterableCampaignFlag?.value === true;

  return (
    <Box
      className={isIterableCampaignActive ? 'active-iterable-campaign' : ''}
      sx={{
        '&.active-iterable-campaign': {
          minHeight: { xs: '54px', sm: '32px' },
          bgcolor: 'background.accent.accent1',
          display: 'flex',
          alignItems: 'center',
        },
      }}
      {...slotProps?.bannerContainer}>
      <IterableEmbeddedSlot
        placementId={Number(placementId)}
        renderer={IterableEmbeddedRenderers.IterableSimpleBanner}
        onRender={(message) => {
          trackAmplitudeEvent(AmplitudeEvent.iterableAssetViewed, {
            data: {
              ...getIterableAmplitudeData(message),
            },
          });
        }}
        onCTAClick={(message) => {
          trackAmplitudeEvent(AmplitudeEvent.iterableAssetClicked, {
            data: {
              ...getIterableAmplitudeData(message),
            },
          });
        }}
      />
    </Box>
  );
};
